import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'm14.1 7.127-5.07-5.06a2.618 2.618 0 0 0-2.08-.82c-1.67.03-4.8 0-4.8 0h-.01a.752.752 0 0 0-.531.22.776.776 0 0 0-.219.54s.029 3.13 0 4.8a2.615 2.615 0 0 0 .82 2.08l5.06 5.07a2.25 2.25 0 0 0 1.529.79 1.649 1.649 0 0 0 1.141-.52l4.419-4.44a1.573 1.573 0 0 0 .531-1.13 2.221 2.221 0 0 0-.79-1.53Zm-.8 1.6-4.43 4.43c-.049.06-.089.08-.089.09a1.327 1.327 0 0 1-.45-.35L3.27 7.827a1.149 1.149 0 0 1-.38-1c.02-1.16.01-3.03.01-4.07 1.04 0 2.909.01 4.07-.01a1.162 1.162 0 0 1 1 .38l5.07 5.06a2.126 2.126 0 0 1 .35.44c-.01.01-.031.04-.09.1Zm-7.21-2.78a1.213 1.213 0 0 1-1.71 0 1.209 1.209 0 0 1 1.71-1.71 1.215 1.215 0 0 1 0 1.71Z';
const draw24px =
  'M21.62,11.42,13.55,3.35a3.7,3.7,0,0,0-3-1.17c-2.63,0-7.61,0-7.65,0h0a.74.74,0,0,0-.74.76c0,.05,0,5,0,7.65a3.78,3.78,0,0,0,1.16,3l8.08,8.07A3.54,3.54,0,0,0,13,22.73a2.07,2.07,0,0,0,.47.06,2.14,2.14,0,0,0,1.52-.7l3.53-3.53L22.05,15C23.64,13.43,22.12,11.92,21.62,11.42ZM21,14,17.46,17.5,13.93,21c-.32.31-.48.27-.57.24a2.38,2.38,0,0,1-.92-.67L4.36,12.53a2.26,2.26,0,0,1-.72-1.92c0-2,0-5.41,0-6.93,1.52,0,4.91,0,6.93,0a2.14,2.14,0,0,1,1.92.73l8.07,8.07C21.52,13.43,21.28,13.67,21,14ZM8.65,6.37A1.64,1.64,0,0,1,6.33,8.69a1.66,1.66,0,0,1,0-2.32A1.64,1.64,0,0,1,8.65,6.37Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const TagIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'tag'),
) as IconWithRender;

TagIcon.displayName = 'TagIcon';
TagIcon.propTypes = Icon.propTypes;
TagIcon.renderIcon = (props) => <TagIcon {...props} />;
export default TagIcon;
